import {
  BackgroundColors,
  NegativeColors,
  PositiveColors,
} from '@picsart/design-system/foundation/colors';

import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    root: {
      marginTop: Spacings.s8,
      '&&': {
        maxWidth: 1024,
      },
    },
    categories: {
      display: 'flex',
      overflow: 'auto',
      alignItems: 'flex-start',
      gap: Spacings.s8,
      '-ms-overflow-style': 'none',
      scrollbarWidth: 'none',
      '@media screen and (max-width: 768px)': {
        overflow: 'auto',
        justifyContent: 'flex-start',
      },
      '&&': {
        justifyContent: 'start',
      },
    },
    chip: {
      backgroundColor: PositiveColors.text.default,
      minWidth: 'fit-content',
      '@media screen and (max-width: 768px)': {
        minWidth: 'fit-content',
      },
      '&:hover:not($selectedChip)': {
        backgroundColor: BackgroundColors.tint1,
      },
    },
    selectedChip: {
      backgroundColor: NegativeColors.base.default,
      '& svg > path': {
        fill: PositiveColors.base.default,
      },
      '& span': {
        color: NegativeColors.text.default,
      },
    },
  },
  {
    name: 'category-style',
  },
);

export default useStyles;
